import { Award, Monitor, Banknote, UserCheck, CheckCircle } from "lucide-react";

const reasons = [
  { icon: Award, title: "Certifié Qualiopi", desc: "Gage de qualité reconnu par l'État" },
  { icon: Monitor, title: "100% En ligne", desc: "Depuis chez vous, à votre rythme" },
  { icon: Banknote, title: "Zéro avance de frais", desc: "100% financé par votre CPF" },
  { icon: UserCheck, title: "Consultants Bac+5 certifiés Qualiopi", desc: "Accompagnement par des professionnels diplômés" },
  { icon: CheckCircle, title: "+80 bilans CPF réalisés en 2025", desc: "Note moyenne 4,8/5 — Démarrage sous 7 à 15 jours" },
];

const WhyUsSection = () => (
  <section className="section-padding bg-muted/50">
    <div className="container mx-auto text-center">
      <h2 className="mb-12 text-3xl font-extrabold md:text-4xl">
        Pourquoi +80 personnes nous ont fait confiance en 2025
      </h2>
      {/* TODO À VALIDER avant publication : "+80 bilans CPF réalisés en 2025" et "Note moyenne 4,8/5" — confirmer ces métriques avec votre catalogue interne */}
      <div className="mx-auto grid max-w-4xl gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {reasons.map((r) => (
          <div key={r.title} className="flex items-start gap-4 rounded-xl p-5 text-left">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <r.icon className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-bold">{r.title}</h3>
              <p className="text-sm text-muted-foreground">{r.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUsSection;
